const initialState = {
  active: false,
  manager: "flow",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "toggle":
      return {
        ...initialState,
        active: !state.active,
      };
    case "open":
      return {
        ...initialState,
        active: true,
        manager: action.manager,
      };
    case "set-manager":
      return {
        ...state,
        manager: action.manager,
      };
    default:
      return initialState;
  }
};

export { reducer, initialState };
